import { useState } from "react";
import { Keyboard } from "react-native";

type Names = readonly string[];
type ModalControlState<T extends Names> = Record<T[number], boolean>;
type SetState<T extends Names> = (f: (s: ModalControlState<T>) => ModalControlState<T>) => void;

type ModalControl = {
  visible: boolean;
  show(): void;
  dismiss(): void;
};

export default function controlModals<T extends Names>(...names: T): () => Record<T[number], ModalControl> {
  const init = Object.fromEntries(names.map((name) => [name, false])) as ModalControlState<T>;

  function buildControls(state: ModalControlState<T>, set: SetState<T>) {
    const toggle = (name: T[number], value: boolean) => () => {
      Keyboard.dismiss();
      set((s) => ({ ...s, [name]: value }));
    };

    return Object.fromEntries(
      names.map((name) => [name, { visible: state[name as T[number]], show: toggle(name, true), dismiss: toggle(name, false) }])
    ) as Record<T[number], ModalControl>;
  }

  return () => {
    const [visible, set] = useState(init);

    return buildControls(visible, set);
  };
}
